module.exports = "<div class=\"for-save-as-image\"><div class=\"nodata\" ng-if=\"!$ctrl.filterData.filterData.cells.length && !$ctrl.filterData.loading\n  && !$ctrl.filterData.cancelled\">{{::'Нет данных' | gettext}}</div><div class=\"total\" ng-style=\"$ctrl.totalStyle\" title=\"{{$ctrl.measureLabel}}\" ng-if=\"!$ctrl.filterData.cancelled && $ctrl.filterData.filterData.cells.length\">{{$ctrl.measureLabel}}<br>{{$ctrl.total}}</div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/stat/summ-stat/summ-stat.component.html
// module id = 429
// module chunks = 0